export default{'Menu':'Menü'};